import axios from 'src/libs/axios';
import { QueryFunctionContext } from '@tanstack/react-query';

const requestOrderPreorder = (url: string, data: any) => {
  return axios({
    method: 'post',
    url,
    data,
  });
};

const getWebMitr = (args: QueryFunctionContext<any>) => {
  const [url, params] = args.queryKey;

  return axios({
    method: 'get',
    url,
    params,
  });
};

const requestOrder = (url: string, data: Payload.OrderReq) => {
  return axios({
    method: 'post',
    url,
    data,
  });
};

export default {
  requestOrderPreorder,
  getWebMitr,
  requestOrder,
};
